/*
- AS_SyncData
-- Syncs the users data
*/
 
import _forEach from 'lodash/forEach';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import config from '@/config';
import ApiS_MakeCall from '@/services/app/api/makeCall';
// import AS_CheckToken from '@/services/app/checkToken';
import AS_StoreSyncData from '@/services/app/storeSyncData';
import { isBefore } from 'date-fns';
import { parseISO } from 'date-fns';
// import RS_UpdateAfterSync from '@/services/reference/updateAfterSync';
import router from '@/router';
import store from '@/store';

export default ($opts) => {
	return new Promise((resolve, reject) => {
		// console.log('AS_SyncData');

		const _$opts = $opts || {};
		const _isStealthSync = (_has(_$opts, 'isStealthSync')) ? _$opts.isStealthSync : false;

		if(!_isStealthSync){
			store.commit('loaders/ADD_ID', 'App');
		}

		let params = {
			lastModifiedDate: '',
		}
	
		// force resync if last sync date is NOT BEFORE a specific date defined in config
		if(!isBefore(parseISO(store.state.lastSyncDate), parseISO(config.forceResyncBeforeDate))){ //2099-01-01T00:00:00
			// do not set a Last Sync Date if the Customer Papers array has content (why was this here?)
			params['lastModifiedDate'] = store.state.lastSyncDate;

		} else {
			console.log('Force Full Resync');

			// clear everything out so it can be fully replaced
			store.commit('LAST_SYNC_DATE', '');
			store.commit('REFERENCE_LIBRARY', []);
			store.commit('REFERENCE_LIBRARY_COMPRESSED_STRING', '');
			store.commit('REFERENCE_LIBRARY_GENESIS', []);
			store.commit('REFERENCE_LIBRARY_GENESIS_COMPRESSED_STRING', '');

		}

		// AS_CheckToken().then(()=>{
			ApiS_MakeCall({
				method: 'GET',
				params,
				responseType: 'json',
				url: 'v4/Sync',
			}).then((responseData)=>{
				if(!config.isLive){
					console.log('v4/sync responseData');
					console.log(responseData);
				}

				AS_StoreSyncData(responseData).then(()=>{
					// 2025.05.02 not sure why i use 'RS_UpdateAfterSync' in the Add-In but not in the SPA
					// RS_UpdateAfterSync().then(()=>{
						return resolve();
					// });//e:RS_UpdateAfterSync

				}).catch(()=>{
					// assume the only returned error will mean the account is expired

					if(router.currentRoute.name === 'YourPapers'){
						// loop through all papers
						responseData.papers.forEach((paper)=>{
							if(!paper.isDeleted){
								
								let paperData = {
									isComplete: paper.isComplete,
									isDeleted: paper.isDeleted,
									isOnlinePaper: true,
									lastModifiedDate: paper.lastModifiedDate || '',
									paperFormatID: paper.paperFormatID,
									paperFormatVersionID: paper.paperFormatVersionID,
									paperID: paper.paperID,
									paperType: paper.paperType,
									title: paper.title,
								}
								
								store.commit('paperList/ADD_PAPER_TO_LIST', paperData);
							}
						});//e:forEach

						return resolve();

					} else {
						router.push({
							name: 'MyProfile',
						}).catch(()=>{});

						return resolve();	
					}
				});//e:AS_StoreSyncData

			});//e:ApiS_MakeCall

		// });//e:AS_CheckToken

	});//e:Promise
}